Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (ctx) {
  var __t,
      __p = '';

  __p += '<ul class="tree-listgroup list-group row"></ul>\n';
  return __p;
};